import { gql } from '@apollo/client';

export const SEARCH_LMS_USERS = gql`
  query SearchLmsUsers($keyword: String!, $options: SearchOptionsInput!) {
    lmsUsersSearch(keyword: $keyword, options: $options) {
      email
      name
      clientRole
      employee {
        commonId
        officeId
        staffCode
        firstName
        lastName
        firstNameKana
        lastNameKana
        officeName
      }
    }
  }
`;

export interface SearchLmsUsersQueryVariables {
  keyword: string;
  options: {
    searchName: boolean;
    searchEmail: boolean;
    searchStaffCode: boolean;
  };
}

export interface SearchLmsUsersQueryResult {
  lmsUsersSearch: LmsUser[];
}

export interface LmsUser {
  email: string;
  name?: string;
  clientRole: string;
  employee?: Employee;
}

interface Employee {
  commonId: string;
  officeId: string;
  staffCode?: string;
  firstName?: string;
  lastName?: string;
  firstNameKana?: string;
  lastNameKana?: string;
  officeName?: string;
}

export const ADD_LMS_USER = gql`
  mutation addLmsUser($input: AddLmsUserInput!) {
    addLmsUser(input: $input) {
      user {
        id
      }
    }
  }
`;

export interface AddLmsUserQueryVariables {
  input: {
    email: string;
    name: string;
    roleCodes: string[];
    employee?: EmployeeInput;
  };
}

interface EmployeeInput {
  commonId: string;
  officeId: string;
  staffCode?: string;
  email: string;
  firstName?: string;
  lastName?: string;
  firstNameKana?: string;
  lastNameKana?: string;
}
